import {
    GET_ORDER_DATA,
    API_URL,
    ORDERDETAILS_PAGE,
    GET_ORDER_DATA_URL,
    RETURNINSTRUCTIONS_PAGE,
    CREATE_RMA_URL,
    GET_RMA_DETAILS,
    GET_ORDER_LISTING_URL,
    GET_ORDER_LISTING,
    ORDERLISTING_PAGE,
    OVERRIDE_ELIGIBLE,
    GET_RMA_DATA_URL,
    GET_API_TOKEN,
    PRODUCTION_PATH,
    GET_MOQUI_SESSION,
    USER_NAME,
    PASSWORD,
    GET_CONTACT_MECH_DATA_URL,
    GET_ITEM_EXCHANGE_DATA_URL
} from "../../AppConfig";

import { logoutMoquiSession } from './loginAction';

// Get API token
export  const  apiToken = () => {
  let username = USER_NAME;
  let password = PASSWORD;
 return fetch(GET_API_TOKEN, {
      method: "GET",
      headers: {"Authorization": "Basic " + btoa(username + ":" + password)},
    }).then(response => response.text())
      .then(res =>{
         return res;
      })
}

export const getRMAData = (returnID) => {
  let api_key= window.sessionStorage.getItem('storeClerkToken');

  return async dispatch => {

    let getRMAURL =API_URL +GET_RMA_DATA_URL+ '?returnIdentifier='+returnID;
    let responseData = {};

    if(!api_key)
      api_key= await apiToken()

    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('api_key', api_key);

    await fetch(getRMAURL,
      {method:'GET',
      headers:headers
    })
      .then(res => res.json())
      .then(RMAData => {
          responseData = RMAData;
        });
    return responseData;
  }
}


// Get Moqui Session Token
export  const  getSessionToken = () => {
  return fetch(GET_MOQUI_SESSION, {
    method: "GET",
    headers: { Accept: "text/plain" }
  }).then(response => response.text())
      .then(res =>{
        return res;
    })
 }

export const fetchContactMechData = async (data) => {
    const getContactMechDataURL = API_URL + GET_CONTACT_MECH_DATA_URL + '?contactMechId=' + data.contactMechId +
        '&facilityId=' + encodeURIComponent(data.facilityId)

    return await fetch(getContactMechDataURL, {
        method: 'GET'
    })
        .then(res => res.json())
        .then(contactMechData => {
            return contactMechData
        })
}

export const fetchExchangeItemsData = async (data) => {
    const getExchangeItemDataURL = API_URL + GET_ITEM_EXCHANGE_DATA_URL + '?productId=' + data.productId;

    return await fetch(getExchangeItemDataURL, {
        method: 'GET'
    })
        .then(res => res.json())
        .then(exchangeData  => {
            return exchangeData
        })
}

// fetch Order Details
export const fetchOrderData = (data, ownProps) => {

  return async dispatch => {
    let returnIdFromOrderListing="";
    let requestedBy ='';

    if(window.sessionStorage.getItem('storeClerkToken'))
     requestedBy ="StoreClerk";
    else
    requestedBy = "Customer";

    let params = ''
    if(data.searchString) params += `&searchString=${encodeURIComponent(data.searchString.trim())}`


    let getOrderDataURL = API_URL + GET_ORDER_DATA_URL + '?orderIdentifier=' + encodeURIComponent(data.orderIdentifier.trim()) +
                          '&storeId=' + data.storeId +
                          '&requestedBy='+ requestedBy +
                          params;

    await fetch(getOrderDataURL, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(orderData => {

        // adding option for return dropdown based on quantity
      for(const returnLabelSetting of Object.keys(orderData.items)) {
        const facilities = orderData.items[returnLabelSetting];
        for(const facilityId of Object.keys(facilities)) {
          const contactMechIds = facilities[facilityId]
          for(const contactMechId of Object.keys(contactMechIds)) {
            const items = contactMechIds[contactMechId]
            for(let item of items) {
                let tempArray = [];
                for (let j = 0; j <= item['quantity']; j++) {
                    tempArray.push({ 'key': j, 'value': j });
                }
                item.options = tempArray
            }
          }
        }
      }

        // sessionStorage.setItem('orderData', JSON.stringify(orderData))

        if(data.returnIdFromOrderListing)
          returnIdFromOrderListing=data.returnIdFromOrderListing

         dispatch({
          type: GET_ORDER_DATA,
          payload: orderData,
          // email: data.email + ' ',
          searchString: data.searchString + ' ',
          orderIdentifier: data.orderIdentifier + ' ',
          returnIdFromOrderListing : returnIdFromOrderListing
        })

          //data.flag =1 - to avoid redirect
        if (!orderData.errorMessage && data.flag!==1) {
          let orderDetailPageURL = PRODUCTION_PATH + data.storeId + ORDERDETAILS_PAGE;
          ownProps.history.push(orderDetailPageURL);
        }
      }
      );
  }
}


// Create RMA for Return Product
export const createRMARequest = (data,ownProps) => {
  return async dispatch => {

    let storeId = window.sessionStorage.getItem('storeId');
    let moquiAPIToken = window.sessionStorage.getItem('storeClerkToken');
    let createRMAURL = API_URL + CREATE_RMA_URL;
    let api_key= window.sessionStorage.getItem('storeClerkToken');
    let orderInput = {"email":data.requestRMAData.returnOrderHeader.email,"orderIdentifier" : data.requestRMAData.returnOrderHeader.orderId,"storeId":storeId,"flag":1};

    if(!api_key)
      api_key= await apiToken()

    let sessionId= await getSessionToken();

    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('api_key', api_key);
    headers.set('moquiSessionToken', sessionId); 

    await fetch(createRMAURL, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data.requestRMAData)
    })
      .then(res => res.json())
      .then(result => {

        if(!result.errors){
          //redirect to tracking url in open new
            if(result.returnLabelUrl)
              window.sessionStorage.setItem('returnLabelUrl', result.returnLabelUrl);

          dispatch(fetchOrderData(orderInput,ownProps));

          if(result.returnLabelUrl) {
            logoutMoquiSession(moquiAPIToken);
          }
          else { //redirect to "print instructions" page
            window.open(PRODUCTION_PATH + storeId + RETURNINSTRUCTIONS_PAGE + '/' + result.returnId, '_self');
          }
        }
        else{
          window.sessionStorage.setItem('shippoError',result.errors);
          dispatch(fetchOrderData(orderInput,ownProps));

          logoutMoquiSession(moquiAPIToken);
         }
      })
  }
}

// fetch RMA details
export  const fetchRMAItemDetails = (returnID) => {

  let api_key= window.sessionStorage.getItem('storeClerkToken');

  return async dispatch => {

    let getRMAURL =API_URL +GET_RMA_DATA_URL+ '?returnIdentifier='+returnID;

    if(!api_key)
      api_key= await apiToken()

    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('api_key', api_key);

    await fetch(getRMAURL,
      {method:'GET',
      headers:headers
    })
      .then(res => res.json())
      .then(RMAData => {
        dispatch({
        type:GET_RMA_DETAILS,
        payload:RMAData
      })
        }
      );
  }
}

// Fetching Order listing data
export  const fetchOrderListing = (data,ownProps) => {

  return async dispatch => {
    let api_key= data.storeClerkToken;
    let getOrderListingURL = API_URL +GET_ORDER_LISTING_URL+
                           '?firstName='+data.firstName +
                           '&lastName='+data.lastName +
                           '&emailAddress='+data.emailAddress +
                           '&orderIdentifier='+data.orderIdentifier+
                           "&storeId="+data.storeId+
                           '&activePage='+data.activePage+
                           '&rowsPerPage='+data.rowsPerPage;

      const headers = new Headers();
      headers.set('api_key', api_key);

    await fetch(getOrderListingURL, {
      method:'GET',
      headers:headers
    })
      .then(res => res.json())
      .then(orderListing => {

        sessionStorage.setItem('orderListing',JSON.stringify(orderListing))

        dispatch({
          type:GET_ORDER_LISTING,
          payload:orderListing,
          orderIdentifier:data.orderIdentifier+' '

        })
        if(!orderListing.errorMessage && !orderListing.errors){
          let orderListingPageURL = PRODUCTION_PATH + data.storeId + ORDERLISTING_PAGE;
          ownProps.history.push(orderListingPageURL);
          }

        }
      );
  }
}

// Override the Eligibility status
export  const overrideEligibleStatus = (data,ownProps) => {

  return async dispatch => {

    let overrideURL = API_URL +OVERRIDE_ELIGIBLE;
    let orderInput = {"email":data.email,"orderIdentifier" : data.orderIdentifier,
                      "storeId":window.sessionStorage.getItem('storeId'),"flag":1};

    let api_key = data.storeClerkToken;

    let sessionId= await getSessionToken();

    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('api_key', api_key);
    headers.set('moquiSessionToken', sessionId);

    await fetch(overrideURL, {
      method:'POST',
      headers: headers,
      body: JSON.stringify(data)

    })
      .then(res => res.json())
      .then(result => {

        if(!result.errorMessage)
          dispatch(fetchOrderData(orderInput,ownProps));
        }
      );
  }
}





// WEBPACK FOOTER //
// ./src/redux/actions/orderAction.js